import {Col, Row, Table} from "react-bootstrap";
import Icon from "../../components/icon";
import PerfectScrollbar from "react-perfect-scrollbar";


export const DomainDns = ({dnsInfo, setDnsInfo, isLoading}) => {


    return (
        <>
            {!isLoading && <div className="card-secondary mt-4">
                <Row>
                    <Col><h6>Dns Check</h6></Col>
                    <Col className="text-end">
                        <a href="#close" onClick={ev => setDnsInfo([])}>
                            <Icon name="close"/>
                        </a>
                    </Col>
                </Row>

                <PerfectScrollbar>
                    <Table>
                        <thead>
                        <tr>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Name</th>
                            <th>Current value</th>
                            <th>Required value</th>
                        </tr>
                        </thead>
                        <tbody>
                        {dnsInfo && dnsInfo.map((record, index) => {
                            return <tr key={`dns_record_${index}`}>
                                <td>{record?.type}</td>
                                <td>{record?.status ? <Icon name="check" color="#0e9b8a"/> :
                                    <Icon name="alert" color="#f00"/>}</td>
                                <td>{record?.name}</td>
                                <td>{record?.value}</td>
                                <td>{record?.required}</td>
                            </tr>
                        })}

                        </tbody>
                    </Table>
                </PerfectScrollbar>
            </div>}
        </>
    )
}